// extracted by mini-css-extract-plugin
export var header = "_so-1";
export var maskBottom = "_so-6";
export var maskMiddle = "_so-7";
export var maskTop = "_so-5";
export var root = "_so-0";
export var scrollDownButton = "_so-3";
export var scrollDownButtonHidden = "_so-4";
export var viewport = "_so-2";